import { Route, Navigate } from 'react-router-dom';
import WhatsAppPage from './pages/WhatsAppPage';
import AutomaticMessagesPage, { RUTA_VIEJA_A_EVENTO } from './pages/AutomaticMessagesPage';

// F2 reorden (24-oct-2026): los 8 mensajes automáticos viven en UNA pantalla (/dashboard/mensajes?evento=<clave>).
// Las rutas viejas siguen funcionando: redirigen al editor correspondiente (enlaces guardados, FAQ, tour, costumbre).
export const WhatsAppRoutes = [
  <Route key="whatsapp" path="/dashboard/whatsapp" element={<WhatsAppPage />} />,
  <Route key="mensajes" path="/dashboard/mensajes" element={<AutomaticMessagesPage />} />,
  ...Object.entries(RUTA_VIEJA_A_EVENTO).map(([ruta, evento]) => (
    <Route key={ruta} path={`/dashboard/${ruta}`} element={<Navigate to={`/dashboard/mensajes?evento=${evento}`} replace />} />
  )),
];
